import React, { useEffect } from 'react'
import { useSpring, animated } from '@react-spring/web'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'

const MyFreebirdOpacityDiscountScreen = ({ isVisible, setShowPopup }) => {
  useEffect(() => {
   // console.log("visible: " + isVisible);
  }, [isVisible]);

  const handleOpacityDiscountClicked = () => {
    console.log('Background clicked!', { isVisible });
    if (isVisible) {
      setShowPopup(false);
    }
  };

  const fadeStyles = useSpring({
    delay: 0,
    config: { duration: 200 },
    from: { opacity: 0 },
    to: { opacity: isVisible ? 0.88 : 0 },
  });

  return (
    <animated.div
      style={{
        backgroundColor: '#000',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1000,
        width: '100vw', 
        height: '100vh', 
        pointerEvents: isVisible ? 'auto' : 'none',
        ...fadeStyles,
      }}
      onClick={handleOpacityDiscountClicked} // Pass the function reference here
    />
  );
};

export default withRouter(withAuth(MyFreebirdOpacityDiscountScreen));
